import { Paychecks } from './index';
import {
  Carrier,
  Feature,
  CardType,
  EventType,
  BadgeColor,
  DepositType,
  CheckoutType,
  PayoutStatus,
  RefundStatus,
  CustomerStatus,
  TrasnactionType,
  SendReceiptType,
  ChargebackReason,
  EventOrderStatus,
  ChargebackStatus,
  MonthlyTaxStatus,
  CloverVoidReason,
  NotificationType,
  EventLocationType,
  NotificationChannel,
  PriceApprovalStatus,
  FiservRetrievalStatus,
  EmployeePaymentMethodType,
} from './enums';

export const RefundStatusTitle = {
  [RefundStatus.Full]: 'Refunded',
  [RefundStatus.Partial]: 'Partial Refunded',
};

export const EventTypeTitle = {
  [EventType.Indoor]: 'Indoor',
  [EventType.Outdoor]: 'Outdoor',
};

export const EventLocationTypeTitle = {
  [EventLocationType.Sqf]: 'SQF',
  [EventLocationType.Corner]: 'Corner',
  [EventLocationType.Endcap]: 'Endcap',
  [EventLocationType.Inline]: 'Inline',
  [EventLocationType.Island]: 'Island',
};

export const EventOrderStatusTitle = {
  [EventOrderStatus.SHIPPED]: 'Shipped',
  [EventOrderStatus.ON_HOLD]: 'On-Hold',
  [EventOrderStatus.CANCELLED]: 'Cancelled',
  [EventOrderStatus.PAID]: 'Awaiting Shipment',
  [EventOrderStatus.UNPAID]: 'Awaiting Payment',
};

export const PriceApprovalStatusTitle = {
  [PriceApprovalStatus.Pending]: 'Pending',
  [PriceApprovalStatus.Approved]: 'Approved',
  [PriceApprovalStatus.Rejected]: 'Rejected',
};

export const PayoutStatusTitle = {
  [PayoutStatus.Lost]: 'Lost',
  [PayoutStatus.Pending]: 'Pending',
  [PayoutStatus.Approved]: 'Approved',
  [PayoutStatus.Paid]: 'Paid Payroll',
  [PayoutStatus.NotApproved]: 'Not approved',
  [PayoutStatus.LostTemporary]: 'Lost Temporary',
  [PayoutStatus.PartialApproved]: 'Partial Approved',
};

export const DepositTypeTitle = {
  [DepositType.Deposit]: 'Deposit',
  [DepositType.HeldFunds]: 'Held funds',
  [DepositType.Withdrawals]: 'Withdrawals',
  [DepositType.ResolvedTransactions]: 'Resolved transactions',
};

export const ChargebackStatusTitle = {
  [ChargebackStatus.Review]: 'Under review',
  [ChargebackStatus.ClosedWon]: 'Closed - WON',
  [ChargebackStatus.ClosedLost]: 'Closed - LOST',
  [ChargebackStatus.ActionRequired]: 'Action required',
};

export const ChargebackReasonTitle = {
  [ChargebackReason.Duplicate]: 'Duplicate Processing',
  [ChargebackReason.IncorrectAmount]: 'Incorrect Amount',
  [ChargebackReason.Defective]: 'Defective/Not as Described',
  [ChargebackReason.GoodsCancelled]: 'Goods/Services Cancelled',
  [ChargebackReason.CancelledService]: 'Cancelled Merchandise/Services',
  [ChargebackReason.AbsentEnvironment]: 'Fraud-Card Absent Environment',
  [ChargebackReason.GoodsReturned]: 'Goods/Services Returned or Refused',
};

export const MonthlyTaxStatusTitle = {
  [MonthlyTaxStatus.Due]: 'Due',
  [MonthlyTaxStatus.Paid]: 'Paid',
  [MonthlyTaxStatus.PartialPaid]: 'Partial paid',
};

export const CardTitle = {
  [CardType.Visa]: 'Visa',
  [CardType.Discover]: 'Discover',
  [CardType.UnionPay]: 'Union Pay',
  [CardType.Mastercard]: 'Mastercard',
  [CardType.AmericanExpress]: 'American Express',
};

export const CustomerStatusTitle = {
  [CustomerStatus.New]: 'New',
  [CustomerStatus.Existing]: 'Existing',
};

export const TransactionTypeTitle = {
  [TrasnactionType.Chargeback]: 'Chargeback',
};

export const EmployeePaymentMethodTypeTitle = {
  [EmployeePaymentMethodType.ACH]: 'ACH',
  [EmployeePaymentMethodType.Wire]: 'Wire',
};

export const PaychecksTitle: Record<
  keyof Omit<
    Paychecks,
    'event' | 'payoutItems' | 'refundAdjustments' | 'chargebackAdjustments'
  >,
  string
> = {
  tipTotal: 'Tip',
  totalPay: 'Pay',
  totalPayout: 'Payout',
  refundTotal: 'Refunds',
  bonusesTotal: 'Bonuses',
  miscPositiveTotal: 'Misc',
  miscNegativeTotal: 'Misc',
  advancesTotal: 'Advances',
  netSalesTotal: 'Net Sales',
  chargebackTotal: 'Chargeback',
  grossSalesTotal: 'Gross Sales',
  commissionsTotal: 'Commissions',
  freeShippingTotal: 'Free Shipping',
  reimbursementsTotal: 'Reimbursements',
};

export const CheckoutTypeTitle = {
  [CheckoutType.Exchange]: 'Exchange',
  [CheckoutType.Purchase]: 'Purchase',
};

export const FeatureTitle: Record<Feature, string> = {
  [Feature.USERS]: 'Users',
  [Feature.ROLES]: 'Roles',
  [Feature.SALES]: 'Sales',
  [Feature.EVENTS]: 'Events',
  [Feature.THEMES]: 'Themes',
  [Feature.CLOVER]: 'Clover',
  [Feature.REPORTS]: 'Reports',
  [Feature.PAYOUTS]: 'Payouts',
  [Feature.CHECKOUT]: 'Checkout',
  [Feature.PRODUCTS]: 'Products',
  [Feature.CARRIERS]: 'Carriers',
  [Feature.ANALYTICS]: 'Analytics',
  [Feature.COMPANIES]: 'Companies',
  [Feature.DASHBOARD]: 'Dashboard',
  [Feature.INVENTORY]: 'Inventory',
  [Feature.SHIPMENTS]: 'Shipments',
  [Feature.EMPLOYEES]: 'Employees',
  [Feature.CUSTOMERS]: 'Customers',
  [Feature.ACCOUNTING]: 'Accounting',
  [Feature.FISERV]: 'Fiserv Chargeback',
  [Feature.USER_PROFILE]: 'User Profile',
  [Feature.EVENT_ORDERS]: 'Event Orders',
  [Feature.NOTIFICATIONS]: 'Notifications',
  [Feature.EVENT_MANAGER]: 'Event Manager',
  [Feature.PRODUCT_TYPES]: 'Product Types',
  [Feature.EVENT_REVIEWS]: 'Event Reviews',
  [Feature.REIMBURSEMENTS]: 'Reimbursements',
  [Feature.PRICE_APPROVAL]: 'Price Approval',
  [Feature.EVENT_EXPENSES]: 'Event Expenses',
  [Feature.PAYMENT_METHODS]: 'Payment Methods',
  [Feature.EVENTS_CALENDAR]: 'Events Calendar',
  [Feature.EMPLOYEE_CREATE]: 'Employee Create',
  [Feature.CUSTOMER_SUPPORT]: 'Customer Support',
  [Feature.RECEIPT_SETTINGS]: 'Receipt Settings',
  [Feature.EVENT_COMPETITION]: 'Event Competition',
  [Feature.EMPLOYEE_COMPETITION]: 'Employee Competition',
};

export const NotificationTitle = {
  [NotificationChannel.App]: 'App',
  [NotificationChannel.Sms]: 'SMS',
  [NotificationChannel.Email]: 'E-mail',
};

export const NotificationTypeTitle: Record<NotificationType, string> = {
  [NotificationType.DayOpen]: 'Day Open',
  [NotificationType.Losses]: 'New Losses',
  [NotificationType.NewEvent]: 'New Event',
  [NotificationType.DayClose]: 'Day Close',
  [NotificationType.NewRefund]: 'New Refund',
  [NotificationType.OfferEvent]: 'Offer Event',
  [NotificationType.NewProduct]: 'New Product',
  [NotificationType.NewExpense]: 'New Expense',
  [NotificationType.NewStorage]: 'New Storage',
  [NotificationType.AcceptEvent]: 'Accept Event',
  [NotificationType.NewSupplier]: 'New Supplier',
  [NotificationType.NewCustomer]: 'New Customer',
  [NotificationType.NewEmployee]: 'New Employee',
  [NotificationType.NewExchange]: 'New Exchange',
  [NotificationType.NewRetrieval]: 'New Retrieval',
  [NotificationType.NewSaleAbove]: 'New Sale Above',
  [NotificationType.NewSaleBelow]: 'New Sale Below',
  [NotificationType.NewChargeback]: 'New Chargeback',
  [NotificationType.NewStockOrder]: 'New Stock Order',
  [NotificationType.NewEventOrder]: 'New Event Order',
  [NotificationType.RefundApproval]: 'Refund Approval',
  [NotificationType.NewEventReview]: 'New Event Review',
  [NotificationType.UpdateRetrieval]: 'Update Retrieval',
  [NotificationType.NewTransferSend]: 'New Transfer Send',
  [NotificationType.UpdateChargeback]: 'Chargeback Updated',
  [NotificationType.NewExchangeOrder]: 'New Exchange Order',
  [NotificationType.DailySalesSummary]: 'Daily Sales Summary',
  [NotificationType.MonthlySalesSummary]: 'Monthly Sales Summary',
  [NotificationType.UpdateStockOrderStatus]: 'Update Stock Order Status',
  [NotificationType.UpdateEventOrderStatus]: 'Update Event Order Status',
  [NotificationType.SaleUnderApproval]: 'Sale under the minimum approval',
  [NotificationType.UpdateExchangeOrderStatus]: 'Update Exchange Order Status',
};

export const CloverVoidReasonTitle = {
  [CloverVoidReason.Fraud]: 'Fraud',
  [CloverVoidReason.Failed]: 'Failed',
  [CloverVoidReason.UserCancel]: 'User Cancel',
  [CloverVoidReason.NotApproved]: 'Not Approved',
  [CloverVoidReason.RejectOffline]: 'Reject Offline',
  [CloverVoidReason.TransportError]: 'Transport Error',
  [CloverVoidReason.RejectSignature]: 'Reject Signature',
  [CloverVoidReason.RejectDuplicate]: 'Reject Duplicate',
  [CloverVoidReason.RejectPartialAuth]: 'Reject Partial Auth',
  [CloverVoidReason.AuthClosedNewCard]: 'Auth Closed New Card',
  [CloverVoidReason.GiftcardLoadFailed]: 'Giftcard Load Failed',
  [CloverVoidReason.UserCustomerCancel]: 'User Customer Cancel',
  [CloverVoidReason.UserGiftcardLoadCancel]: 'User Giftcard Load Cancel',
  [CloverVoidReason.DeveloperPayPartialAuth]: 'Developer Pay Partial Auth',
  [CloverVoidReason.DeveloperPayTipAdjustFailed]:
    'Developer Pay Tip Adjust Failed',
};

export const CarrierTitle = {
  [Carrier.UPS]: 'UPS',
  [Carrier.USPS]: 'USPS',
  [Carrier.FedEx]: 'FedEx',
};

export const SendReceiptTypeTitle = {
  [SendReceiptType.Default]: 'Receipt',
  [SendReceiptType.Gift]: 'Gift Receipt',
};

export const FiservRetrievalTitle = {
  [FiservRetrievalStatus.Closed]: 'Closed',
  [FiservRetrievalStatus.Open]: 'Action Required',
  [FiservRetrievalStatus.InProgress]: 'In Progress',
  [FiservRetrievalStatus.Responded]: 'Response Submitted',
  [FiservRetrievalStatus.Escalated]: 'Escalated to Chargeback',
};

export const FiservRetrievalStatusColor = {
  [FiservRetrievalStatus.Open]: BadgeColor.Red,
  [FiservRetrievalStatus.Closed]: BadgeColor.Green,
  [FiservRetrievalStatus.Escalated]: BadgeColor.Red,
  [FiservRetrievalStatus.Responded]: BadgeColor.Blue,
  [FiservRetrievalStatus.InProgress]: BadgeColor.Yellow,
};
